import React from 'react';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';
import Seo from '../components/Seo';
import './LegalPage.css';

const ImprintPage = () => {
  return (
    <div className="legal-page">
      <Seo
        title="Impressum | Sportphysiotherapie Oliver Bauer"
        description="Pflichtangaben und Kontaktdaten der Sportphysiotherapie Oliver Bauer in Hornstein für Patient:innen aus Leobersdorf, Wiener Neustadt und Umgebung."
        canonical="/impressum"
      />
      <Navigation activeSection="" simple />
      <main className="legal-wrapper">
        <section className="legal-content">
          <h1 className="heading-2">Impressum</h1>
          <p className="body-large section-subtitle">
            Pflichtangaben gemäß § 5 E-Commerce-Gesetz
          </p>

          <div className="legal-block">
            <p className="legal-label">Anbieter, Anschrift, Kontakt</p>
            <address>
              Oliver Bauer<br />
              Alte Bandfabrik 1<br />
              A – 7053 Hornstein<br />
              <a href="tel:+436641510494">+43 664 15 10 494</a><br />
              <a href="mailto:office@physiotherapie-oliverbauer.com">office@physiotherapie-oliverbauer.com</a>
            </address>
          </div>

          <div className="legal-block">
            <p className="legal-label">Unternehmensgegenstand</p>
            <p>Praxis für Physiotherapie · Gemeinschaftspraxis</p>
          </div>

          <div className="legal-block">
            <p className="legal-label">Berufsbezeichnung</p>
            <p>Physiotherapeut</p>
          </div>

          <div className="legal-block">
            <p className="legal-label">Berufsrecht</p>
            <p>
              MTD-Gesetz (BGBlNr. 100/2024 idgF) –{' '}
              <a
                href="https://ris.bka.gv.at/eli/bgbl/I/2024/100"
                target="_blank"
                rel="noopener noreferrer"
              >
                online abrufbar
              </a>
              . Eintragung im Gesundheitsberufsregister Österreich.
            </p>
          </div>

          <div className="legal-block">
            <p className="legal-label">Urheberrecht</p>
            <p>
              Alle Inhalte dieser Website (Texte, Bilder, Videos etc.) sind urheberrechtlich geschützt. Eine Nutzung
              oder Weitergabe bedarf der schriftlichen Genehmigung von Oliver Bauer. Bei unerlaubter Nutzung behalte ich
              mir rechtliche Schritte vor.
            </p>
          </div>

          <div className="legal-block">
            <p className="legal-label">Haftungsausschluss</p>
            <p>
              Die Inhalte wurden sorgfältig erstellt. Für Richtigkeit, Vollständigkeit und Aktualität kann dennoch keine
              Haftung übernommen werden.
            </p>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default ImprintPage;
